import { Theme, createStyles } from '@forgeglobal/design-framework';

export const boundaryStyles = (theme: Theme) =>
  createStyles({
    wrapper: {
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
    },
    spacer: {
      flexBasis: '20%',
      minHeight: theme.spacing(4),
    },
  });

export const defaultErrorStyle = (theme: Theme) =>
  createStyles({
    container: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      marginBottom: theme.spacing(12.5),
    },
    message: {
      paddingTop: theme.spacing(6),
    },
    supportMessage: {
      paddingTop: theme.spacing(3),
    },
  });
